const isTouchDevice = (): boolean => {
  return 'ontouchstart' in window || (window.navigator as any).maxTouchPoints > 0 || (window.navigator as any).msMaxTouchPoints > 0;
}

export default isTouchDevice
